(() => {
  const initialise = (root) => {
    if (root.dataset.gsSupportReady) return;
    root.dataset.gsSupportReady = 'true';
    const date = root.querySelector('[data-gs-delivery-date]');
    if (date) {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'}).formatToParts(new Date()).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
      const delivery = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
      let days = parts.hour >= 14 ? 2 : 1;
      while (days > 0) { delivery.setUTCDate(delivery.getUTCDate() + 1); if (delivery.getUTCDay() !== 0 && delivery.getUTCDay() !== 6) days -= 1; }
      date.textContent = new Intl.DateTimeFormat('en-GB', {timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'short'}).format(delivery);
    }
    root.querySelectorAll('[data-gs-support-dialog-open]').forEach(trigger => {
      const dialog = document.getElementById(trigger.dataset.gsSupportDialogOpen);
      if (!dialog) return;
      trigger.addEventListener('click', event => { event.preventDefault(); dialog.showModal(); });
    });
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelectorAll('[data-gs-support-dialog-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    });
    const accordions = [...root.querySelectorAll('.gs-pdp-faq')];
    accordions.filter(item => item.open).slice(1).forEach(item => { item.open = false; });
    accordions.forEach(item => item.addEventListener('toggle', () => { if (item.open) accordions.forEach(other => { if (other !== item) other.open = false; }); }));
    const tabs = [...root.querySelectorAll('[data-gs-review-tab]')];
    const panels = [...root.querySelectorAll('[data-gs-review-panel]')];
    const activate = (tab, focus) => {
      tabs.forEach(button => { const active = button === tab; button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.dataset.gsReviewPanel !== tab.dataset.gsReviewTab; if (!panel.hidden) panel.dispatchEvent(new Event('gs-support-review-show')); });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); activate(tabs[next], true);
      });
    });
    panels.forEach(panel => {
      const track = panel.querySelector('[data-gs-review-track]');
      const previous = panel.querySelector('[data-gs-review-prev]');
      const next = panel.querySelector('[data-gs-review-next]');
      const update = () => { previous.disabled = track.scrollLeft <= 1; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      const step = direction => {
        const card = track.querySelector('.gs-pdp-review-card');
        const amount = card ? card.getBoundingClientRect().width + 12 : track.clientWidth;
        track.scrollBy({left: direction * amount, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => step(-1)); next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, {passive: true});
      panel.addEventListener('gs-support-review-show', () => requestAnimationFrame(update));
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  };
  document.querySelectorAll('[data-gs-pdp-support]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gs-pdp-support]').forEach(initialise));
})();
